import script from "./GraphScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphScreen.vue?vue&type=script&setup=true&lang=js"

import "./GraphScreen.vue?vue&type=style&index=0&id=ada2be72&lang=scss&scoped=true"

import exportComponent from "/Users/cricle/Documents/monetware/code/web/knowledgeGraph-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada2be72"]])

export default __exports__